import { render, staticRenderFns } from "./PcOnly.vue?vue&type=template&id=372f7ecb&"
import script from "./PcOnly.vue?vue&type=script&lang=js&"
export * from "./PcOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports